import CustomLink from '@pickleballinc/ui/components/ui/custom-link';
import { Fragment } from 'react';

import { FeaturedPlayer } from '@/components/FeaturedPlayer/FeaturedPlayer';
import { PlayerResponse } from '@/types/homepage.types';

export interface FeaturedPlayersContainerProps {
  title: string;
  players: PlayerResponse[];
  linkUrl?: string;
  linkText?: string;
  showRankingsAndSponsors?: boolean;
  rankingsType?: string;
}

export const FeaturedPlayersContainer = ({
  title,
  linkText,
  linkUrl,
  players,
  showRankingsAndSponsors,
  rankingsType,
}: FeaturedPlayersContainerProps) => {
  if (players.length === 0) return null;

  return (
    <div className='flex w-full flex-col items-center rounded-xl bg-white'>
      <div className='w-full py-4 pl-[18px] text-left text-sm font-bold leading-5 tracking-normal'>
        {title}
      </div>
      {players.map((featuredPlayer, index) => (
        <Fragment key={featuredPlayer.uuid}>
          <FeaturedPlayer
            player={featuredPlayer}
            lastFeatured={index === players.length - 1}
            showRankingsAndSponsors={showRankingsAndSponsors}
            rankingsType={rankingsType}
          />
          {index !== players.length - 1 && (
            <div className='w-full border-t border-solid border-gray-200 pb-4' />
          )}
        </Fragment>
      ))}
      <div className='line-clamp-2 flex w-full justify-center px-[18px] py-4 text-center'>
        <CustomLink
          className='text-sm font-semibold text-experiment hover:underline'
          href={linkUrl || `/players`}
        >
          {linkText || 'See all'}
        </CustomLink>
      </div>
    </div>
  );
};
